import { api } from 'lib/httpClient';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { ApiResponse } from 'further-types/api';
import { Api } from 'further-types/eis-wizard';
import { QUERY_STALE_TIME_MS } from 'further-ui/config';

export default function useEisTasklist(
  params: Api.GetEisWizardTaskListRequest,
) {
  const tasklist = useQuery({
    queryKey: ['eis-tasklist', params],
    queryFn: async () => {
      return (
        await api.get<ApiResponse<Api.GetEisWizardTaskListResponse>>(
          `/eis-wizard`,
          { params },
        )
      ).data.data;
    },
    placeholderData: keepPreviousData,
    staleTime: QUERY_STALE_TIME_MS,
  });

  return {
    tasklist,
  };
}
